
export default {
  namespaced: true,
  state: () => ({
    contact: null
  }),
  mutations: {
    setContact (state, contact) {
      state.contact = contact
    }
  },
}